/**
 * BreathingRepository — breathing session history, append-mostly.
 */
import { requireSupabase } from '@/lib/supabase/client'
import {
  breathingSessionFromRow,
  breathingSessionToInsert,
  type BreathingSessionRow,
} from '@/lib/supabase/mappers'
import type { BreathingRepository } from '../interfaces'
import { assertRowReturned, fail, requireUserId } from './helpers'

export const breathingRepository: BreathingRepository = {
  async listSessions(limit = 30) {
    const supabase = requireSupabase()
    const userId = await requireUserId()
    const { data, error } = await supabase
      .from('breathing_sessions')
      .select('*')
      .eq('user_id', userId)
      .order('started_at', { ascending: false })
      .limit(limit)
    if (error) fail(error)
    return ((data ?? []) as BreathingSessionRow[]).map(breathingSessionFromRow)
  },

  async saveSession(input) {
    const supabase = requireSupabase()
    const userId = await requireUserId()
    const { data, error } = await supabase
      .from('breathing_sessions')
      .insert(breathingSessionToInsert(input, userId))
      .select()
      .single()
    return breathingSessionFromRow(assertRowReturned(data, error) as BreathingSessionRow)
  },
}
